module.exports = __webpack_public_path__ + "img/natural_material.af93b0e2.svg";